/**
 * Hysteresis for the "loading video" chip.
 *
 * Raw buffering state flips true/false at scrub speed — a hard seek drops
 * readyState to 1 on every pointer move — so binding the chip straight to it
 * strobes. Delay showing (most stalls resolve within the delay and should never
 * have been announced) and, once shown, hold it briefly so it reads as a state
 * rather than a flash.
 */
import { useEffect, useRef, useState } from 'react';

const SHOW_DELAY_MS = 150;
const MIN_VISIBLE_MS = 400;

export function useBufferingIndicator(active: boolean): boolean {
  const [visible, setVisible] = useState(false);
  const shownAt = useRef(0);

  useEffect(() => {
    let timer = 0;
    if (active && !visible) {
      timer = window.setTimeout(() => {
        shownAt.current = performance.now();
        setVisible(true);
      }, SHOW_DELAY_MS);
    } else if (!active && visible) {
      const held = performance.now() - shownAt.current;
      timer = window.setTimeout(() => setVisible(false), Math.max(0, MIN_VISIBLE_MS - held));
    }
    return () => clearTimeout(timer);
  }, [active, visible]);

  return visible;
}
